import {WaveLoader} from '@wandb/weave/components/Loaders/WaveLoader';
import {TailwindContents} from '@wandb/weave/components/Tailwind';
import {clsx} from 'clsx';
import React from 'react';

import {useSingleRunModeContext} from '../MultiRunWorkspace/SingleRunMode';

export const TabWaveLoader = () => {
  const {isSingleRun} = useSingleRunModeContext();

  return (
    <TailwindContents>
      <div
        className={clsx(
          'flex justify-center h-full',
          isSingleRun ? 'mt-[100px] items-start' : 'items-center'
        )}>
        <WaveLoader size={'huge'} />
      </div>
    </TailwindContents>
  );
};
